import Vue from 'vue';
import VueRouter from 'vue-router';

import db from '@/db';

import Projects from '../views/Projects.vue';
import Statistics from '../views/Statistics.vue';
import Config from '../views/Config.vue';
import Onboarding from '../views/Onboarding.vue';


Vue.use(VueRouter);


const routes = [
  {
    path: '/config',
    name: 'Config',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Config,
  },
  {
    path: '/statistics',
    name: 'Statistics',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Statistics,
  },
  {
    path: '/projects',
    name: 'Projects',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Projects,
    async beforeEnter(to, from, next) {
      // hier wird die Einstellung aus der Datenbank geladen
      const onboardingComplete = await db.config.get('onboardingComplete');
      // Falls die Einstellung nicht existiert ODER der Wert nicht true ist, leiten wir weiter
      if (!onboardingComplete || !onboardingComplete.value) next({ name: 'Onboarding' });
      // ansonsten können wir auf Home gehen
      else next();
    },
  },
  {
    path: '/',
    name: 'Onboarding',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Onboarding,
    async beforeEnter(to, from, next) {
      const onboardingComplete = await db.config.get('onboardingComplete');
      if (onboardingComplete && onboardingComplete.value) next({ name: 'Projects' });
      else next();
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
